import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorHandlerService } from '@services/error-handler.service';

export const errorsInterceptor: HttpInterceptorFn = (req, next) => {
    const errorHandlerService = inject(ErrorHandlerService);

    return next(req).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status !== 401 && !error.url?.includes('/assets')) {
                errorHandlerService.errorHandler(error);
            }
            return throwError(() => error);
        })
    );
};
